import {
  DiscountAllocation,
  Order,
  OrderLineItem
} from '@components/account/types'
import { parse } from '@helpers/shopify'

export type OrderItem = {
  image: {
    url?: string
  }
  price: string
  currentTotalPrice: string
  totalDiscount?: string
  title: string
  productType: string
  quantity: number
  refundableQuantity: number
  variantId: string | null
  productId: string
  discountAllocations: DiscountAllocation[] | null
  customAttributes: {
    value: string
    key: string
  }[]
}

const mapLineItemToOrderItem = (item: OrderLineItem): OrderItem => ({
  variantId: item.variantId,
  productId: item.productId,
  price: item.price.amount,
  currentTotalPrice: item.currentTotalPrice?.amount,
  totalDiscount: item.totalDiscount?.amount,
  title: item.title,
  productType: item.productType,
  quantity: item.quantity,
  refundableQuantity: item.refundableQuantity,
  customAttributes: item.customAttributes,
  discountAllocations: item.discountAllocations,
  image: { url: item.image?.url }
})

export type CustomOrder = Order & { orderItems: OrderItem[] }

export function transformOrder(order: Order): CustomOrder {
  if (!order) return order
  const data = parse(order) as Order

  if (!data || typeof data !== 'object' || Array.isArray(data)) {
    throw new Error('Parsed order data is not an object')
  }

  return {
    ...data,
    orderItems: data.lineItems.map(mapLineItemToOrderItem)
  }
}
